import { useState, useCallback } from 'react';

export const useChemoSearch = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [dateSearch, setDateSearch] = useState({
        startDate: '',
        endDate: ''
    });

    const filterReports = useCallback((reports, term) => {
        if (!term) return reports;

        const lowerSearch = term.toLowerCase();
        return reports.filter(report =>
            report.reportNumber?.toLowerCase().includes(lowerSearch) ||
            report.reportDate?.toLowerCase().includes(lowerSearch) ||
            report.createdBy?.toLowerCase().includes(lowerSearch) ||
            report.status?.toLowerCase().includes(lowerSearch)
        );
    }, []);

    const handleSearchChange = useCallback((value) => {
        setSearchTerm(value);
    }, []);

    const updateDateSearch = useCallback((field, value) => {
        setDateSearch(prev => ({ ...prev, [field]: value }));
    }, []);

    const formatDate = useCallback((dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }, []);

    return {
        searchTerm,
        dateSearch,
        filterReports,
        handleSearchChange,
        updateDateSearch,
        formatDate
    };
};
